import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const DatenschutzPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Back button */}
        <button
          onClick={() => navigate('/')}
          className="mb-8 px-4 py-2 bg-secondary hover:bg-secondary/80 text-white rounded-xl flex items-center gap-2 transition-all"
        >
          <ArrowLeft className="w-5 h-5" />
          Zurück
        </button>

        <h1 className="text-4xl font-bold mb-8">Datenschutzerklärung</h1>

        <div className="space-y-8 text-muted-foreground">
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">1. Datenschutz auf einen Blick</h2>
            
            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
              persönlich identifiziert werden können.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Datenerfassung auf dieser Website</h3>
            <p className="mb-4">
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
            </p>
            <p>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
              können Sie dem Impressum dieser Website entnehmen.
            </p>

            <p className="mb-4 mt-6">
              <strong>Wie erfassen wir Ihre Daten?</strong>
            </p>
            <p>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. 
              um Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p className="mt-4">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere 
              IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder 
              Uhrzeit des Seitenaufrufs).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">2. Hosting</h2>
            <p>
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, 
              werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, 
              Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, 
              die über eine Website generiert werden, handeln.
            </p>
            <p className="mt-4">
              Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und 
              bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und 
              effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            
            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie 
              dieser Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Hinweis zur verantwortlichen Stelle</h3>
            <p>
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="mt-4">
              <strong>Freys Media</strong><br />
              Inhaber: Kenny Frey<br />
              Wöschhalde 7<br />
              78052 VS-Villingen<br />
              Deutschland
            </p>
            <p className="mt-4">
              Telefon: 0173 4793306<br />
              E-Mail: kenny@freysmedia.de
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Speicherdauer</h3>
            <p>
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben 
              Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p>
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine 
              bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten 
              Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Auskunft, Löschung und Berichtigung</h3>
            <p>
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche 
              Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck 
              der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">4. Datenerfassung auf dieser Website</h2>
            
            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Server-Log-Dateien</h3>
            <p>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, 
              die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className="mt-4">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser 
              Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
              inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall 
              von Anschlussfragen bei uns gespeichert.
            </p>
            <p className="mt-4">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage 
              mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen 
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse 
              an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
            </p>

            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Anfrage per E-Mail oder Telefon</h3>
            <p>
              Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden 
              personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert 
              und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">8. Externe Inhalte und Dienste</h2>
            
            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Instagram Feed Integration</h3>
            <p className="mb-4">
              Unsere Website bindet Inhalte von Instagram (Meta Platforms Ireland Limited) ein. Wenn Sie Seiten unserer Website besuchen, die Instagram-Inhalte enthalten, wird eine direkte Verbindung zwischen Ihrem Browser und den Instagram-Servern hergestellt.
            </p>
            <p className="mb-4">
              <strong>Zweck:</strong> Darstellung aktueller Social-Media-Inhalte und Portfolios<br />
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)<br />
              <strong>Datenempfänger:</strong> Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland
            </p>
            <p className="mb-4">
              Durch die Einbindung erhält Instagram die Information, dass Sie unsere Website besucht haben. Dabei können auch personenbezogene Daten (wie Ihre IP-Adresse) an Meta-Server in den USA übertragen und dort gespeichert werden.
            </p>
            <p className="mb-4">
              Instagram kann Ihre Daten für eigene Zwecke verwenden, insbesondere für Werbezwecke, Marktforschung und bedarfsgerechte Gestaltung ihrer Dienste. Hierfür werden Nutzungsprofile erstellt.
            </p>
            <p className="mb-4">
              Weitere Informationen finden Sie in der Datenschutzerklärung von Instagram/Meta:<br />
              <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--accent))] hover:underline">
                https://help.instagram.com/519522125107875
              </a>
            </p>
            <p className="mb-4">
              Wenn Sie nicht möchten, dass Instagram die über unsere Website gesammelten Daten Ihrem Instagram-Konto zuordnet, müssen Sie sich vor dem Besuch unserer Website bei Instagram ausloggen.
            </p>
            
            <h3 className="text-xl font-semibold text-foreground mb-3 mt-6">Weitere externe Dienste</h3>
            <p>
              Auf dieser Website können weitere externe Inhalte und Dienste eingebunden sein (z. B. Videos von YouTube, 
              Kartenmaterial von Google Maps). Die Einbindung dieser Dienste erfolgt erst nach Ihrer Einwilligung 
              und setzt voraus, dass Sie Cookies akzeptieren.
            </p>
          </section>

          <p className="text-sm mt-12">
            Stand: Januar 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
